import { Badge, Button, Card, Carousel } from "react-bootstrap";
import Moment from "react-moment";
import { RxCalendar } from "react-icons/rx";
import { useState } from "react";
import { NavLink } from "react-router-dom";

const SitePilotIntegrationPreview = ({ singleSitePilotIntegration }) => {
  const [openModule, setOpenModule] = useState("overview");

  return (
    <>
      <div className="py-2 position-relative">
        {singleSitePilotIntegration?.installationDetails && (
          <div className="hstack gap-2 pb-2 position-sticky z-2 top-0 bg-white justify-content-end">
            <Button
              variant={
                openModule === "overview" ? "primary" : "outline-primary"
              }
              size="sm"
              onClick={() => setOpenModule("overview")}
            >
              Overview
            </Button>
            <Button
              variant={
                openModule === "installation" ? "primary" : "outline-primary"
              }
              size="sm"
              onClick={() => setOpenModule("installation")}
            >
              Installation
            </Button>
          </div>
        )}
        <Card className="border mb-3">
          {openModule === "overview" &&
            singleSitePilotIntegration?.banners?.length > 0 && (
              <>
                {singleSitePilotIntegration?.sliders ? (
                  <Carousel interval={3000} indicators>
                    {singleSitePilotIntegration?.banners?.map((icon, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 rounded"
                          src={icon}
                          alt={`Slider ${index + 1}`}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  <div className="mb-3">
                    <img
                      className="d-block w-100 rounded"
                      src={singleSitePilotIntegration?.banners?.[0]}
                      alt="Slider"
                    />
                  </div>
                )}
              </>
            )}
          <Card.Body>
            {openModule === "overview" && (
              <>
                {singleSitePilotIntegration?.tags?.length > 0 && (
                  <div className="hstack justify-content-between mb-2">
                    <p
                      style={{ fontSize: 14 }}
                      className="text-muted m-0 hstack gap-1 flex-wrap"
                    >
                      <span className="fw-bold">Works With: </span>
                      {singleSitePilotIntegration?.tags?.map((tags, index) => (
                        <Badge className="rounded-1" key={index}>
                          {tags}
                        </Badge>
                      ))}
                    </p>
                  </div>
                )}
                <div
                  dangerouslySetInnerHTML={{
                    __html: singleSitePilotIntegration?.overview,
                  }}
                />
              </>
            )}
            {openModule === "installation" && (
              <div
                dangerouslySetInnerHTML={{
                  __html: singleSitePilotIntegration?.installationDetails,
                }}
              />
            )}
          </Card.Body>
          <div className="justify-content-end p-2 border-top hstack gap-2">
            <NavLink to={singleSitePilotIntegration?.learnMoreButtonKey || "#"} target="_blank">
              <Button
                size="sm" style={{fontSize: 12}}
                disabled={!singleSitePilotIntegration?.learnMoreButton}
                variant="outline-primary"
                title={`Learn more about this integration`}
              >
                Learn More
              </Button>
            </NavLink>
            {singleSitePilotIntegration?.installButton && (
              singleSitePilotIntegration?.installButtonActionType === "activate" ?
                <Button size="sm" style={{fontSize: 12}} variant="primary" title={`Install this`}>
                  Install Now
                </Button>
                :
                <NavLink to={singleSitePilotIntegration?.installButtonKey || "#"} target="_blank">
                  <Button size="sm" style={{fontSize: 12}} variant="primary" title={`Install this`}>
                    Install Now
                  </Button>
                </NavLink>
            )}
          </div>
        </Card>
      </div>
    </>
  );
};

export default SitePilotIntegrationPreview;
